export default class fileDownloader {
  constructor() {
    this.requests = new Map();
  }
  //Parameters:A url to a downloadable file, and optional functions that handle progress, loadend, and error events
  //Function: After promise resolves, returns blob
  getBlob(downloadUrl, handleProgress, handleLoadEnd, handleError) {
    let me = this;
    return new Promise(function (resolve, reject) {
      let xmlReq = new XMLHttpRequest();
      if (handleLoadEnd != null) {
        xmlReq.addEventListener('loadend', handleLoadEnd);
      }
      if (handleProgress != null) {
        xmlReq.addEventListener('progress', handleProgress);
      }
      if (handleError != null) {
        xmlReq.addEventListener('error', handleError);
      }
      xmlReq.open("GET", downloadUrl, true);
      xmlReq.responseType = "blob";
      xmlReq.onload = function () {
        if (200 <= xmlReq.status && 300 > xmlReq.status) {
          resolve(xmlReq.response);
        } else {
          reject(xmlReq.statusText);
        }
      };
      me.requests.set(downloadUrl, xmlReq);
      xmlReq.send(null);
    });
  }
  abortAll() {
    this.requests.forEach((value,key,map) => {
      value.abort()
    });
  }
};
